const convertTier = (flag) => {
	const score = Number(flag)
	if (!Number.isFinite(score) || score < 1) return '없음'
	if (score < 500) return 'BRONZE'
	if (score < 1000) return 'SILVER'
	if (score < 1500) return 'GOLD'
	if (score < 2000) return 'PLATINUM'
	if (score < 2500) return 'DIAMOND'
	return 'CHALLENGER'
}

export default convertTier
